import React, { Component } from "react";
import { Layout, Menu, Button, Dropdown, BackTop, message } from "antd";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Login from "./pages/Login";
import QuickStart from "./pages/manual/QuickStart";
import FullManual from "./pages/manual/FullManual";
import { getToken, setToken, getTokenData, TokenData } from "./utils";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "./pages/Dashboard";
import Support from "./pages/Support";
import Api from "./api";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import PurchaseCredits from "./pages/credits/PurchaseCredits";
import {
  CaretDownOutlined,
  UserOutlined,
  LogoutOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import * as Sentry from "@sentry/react";
import { AffiliateStats } from "./pages/AffiliateStats";
import { RecommendedGear } from "./pages/RecommendedGear";
import { SubscriptionCheckout } from "./pages/subscription/SubscriptionCheckout";
import { Account } from "./pages/account/Account";
import { SubscriptionCheckoutResult } from "./pages/subscription/SubscriptionCheckoutResult";
import { MultipleInstances } from "./pages/manual/MultipleInstances";
import { Focus3Setup } from "./pages/manual/Focus3Setup";
import { ValidateLoginCode } from "./pages/ValidateLoginCode";
import { DownloadPage } from "./pages/Download";
import { Welcome } from "./pages/Welcome";
import { Marketing } from "./pages/marketing/Marketing";
import { DiagnoseManual } from "./pages/manual/DiagnoseManual";
import { PicoLBE } from "./pages/manual/PicoLBE";
import { UpdateManual } from "./pages/manual/Update";
import { ReleaseChannels } from "./pages/manual/ReleaseChannels";
import { PatchNotes } from "./pages/PatchNotes";
import { PatchNoteReleasePage } from "./pages/PatchNoteRelease";
const { Header, Content } = Layout;
type Props = {};
type State = {
  auth: TokenData | undefined;
  currentMenuKey: string | undefined;
};
class App extends Component<Props, State> {
  state: State = { auth: undefined, currentMenuKey: undefined };
  componentDidMount() {
    this.initAuth();

    const currentMenuKey = window.location.pathname;
    this.setState({ currentMenuKey });
  }

  initAuth = async () => {
    const token = getToken();
    if (!token) return;
    try {
      const auth = getTokenData();
      this.setState({ auth });
      if (!auth || !auth.isValid) {
        message.info("Login expired. Please log in again.");
        setTimeout(() => {
          this.handleLogout();
        }, 2000);
      }
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
    }
    this.refreshToken();
  };
  refreshToken = async () => {
    try {
      const newToken = await Api.get("/api/refresh_token");
      if (newToken?.token) {
        setToken(newToken.token);
      }
    } catch (error) {
      this.handleLogout();
    }
  };
  handleLogout = () => {
    setToken("");
    // clearCookie("userSession");
    this.setState({ auth: undefined });
    window.location.reload();
  };

  handleMenuClick = (e: any) => {
    this.setState({
      currentMenuKey: e.key,
    });
  };

  render() {
    return (
      <Layout className="layout">
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            color: "#fff",
          }}
        >
          <div className="header-nav">
            <a href="/" className="header-logo">
              <img
                src="/images/HeroZone-Logo-Gradient.svg"
                alt="logo"
                style={{ height: 28, display: "block" }}
              />
            </a>
            <Menu
              disabledOverflow
              onClick={this.handleMenuClick}
              mode="horizontal"
              selectedKeys={[this.state.currentMenuKey || "-1"]}
              selectable
              style={{
                lineHeight: "64px",
                background: "transparent",
                border: "none",
                flex: "none",
              }}
            >
              <Menu.Item key="/welcome">
                <a href="/welcome">WELCOME</a>
              </Menu.Item>
              <Menu.Item key="/">
                <a href="/">DASHBOARD</a>
              </Menu.Item>
              <Menu.Item key="/manual">
                <a href="/manual">MANUAL</a>
              </Menu.Item>
              <Menu.Item key="/quick-start">
                <a href="/quick-start">QUICK START</a>
              </Menu.Item>
              <Menu.Item key="/account">
                <a href="/account">ACCOUNT</a>
              </Menu.Item>
              <Menu.Item key={"marketing"}>
                <a href="/marketing">MARKETING</a>
              </Menu.Item>
            </Menu>
          </div>
          <div>
            {this.state.auth ? (
              <Dropdown
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="user-menu-dropdown"
                overlay={
                  <Menu>
                    <Menu.Item
                      key="account"
                      icon={<UserOutlined />}
                      onClick={() => {
                        window.location.href = "/account";
                      }}
                    >
                      Account
                    </Menu.Item>
                    <Menu.Item
                      key="signout"
                      icon={<LogoutOutlined />}
                      onClick={this.handleLogout}
                    >
                      Sign Out
                    </Menu.Item>
                  </Menu>
                }
              >
                <div className="user-menu-trigger">
                  <span className="user-menu-avatar">
                    <UserOutlined />
                  </span>
                  <span className="user-menu-email">
                    {this.state.auth?.email}
                  </span>
                  <CaretDownOutlined style={{ fontSize: 10, opacity: 0.6 }} />
                </div>
              </Dropdown>
            ) : (
              <a href="/login">
                <Button
                  style={{
                    borderRadius: 8,
                    fontWeight: 600,
                    fontSize: 12,
                    letterSpacing: "0.06em",
                  }}
                >
                  LOGIN
                </Button>
              </a>
            )}
          </div>
        </Header>
        <Content className="app-content">
          <BackTop visibilityHeight={300}>
            <div className="back-to-top" aria-label="Back to top">
              <ArrowUpOutlined />
            </div>
          </BackTop>
          <Router>
            <div
              style={{
                maxWidth: "1600px",
                width: "100%",
                display: "flex",
                alignItems: "start",
                justifyContent: "center",
              }}
            >
              <PrivateRoute path="/" exact component={Dashboard} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/forgot-password" component={ForgotPassword} />

              {/* <Route path="/signup" component={Signup} /> */}
              <Route path="/login" component={Login} />
              <PrivateRoute path="/credits" component={PurchaseCredits} />
              <PrivateRoute
                path="/purchase-subscription"
                component={SubscriptionCheckout}
              />
              <PrivateRoute
                path="/purchase-subscription-result"
                component={SubscriptionCheckoutResult}
              />
              <PrivateRoute path="/account" component={Account} />

              <Route path="/support" component={Support} />
              <Route path="/quick-start" component={QuickStart} />
              <Route path="/manual" component={FullManual} />
              <Route path="/download" component={DownloadPage} />
              <PrivateRoute path="/welcome" component={Welcome} />
              <Route path="/recommended-gear" component={RecommendedGear} />
              <Route path="/multiple-instances" component={MultipleInstances} />
              <Route path="/multiple-arenas" component={MultipleInstances} />
              <Route path="/diagnostic-tool" component={DiagnoseManual} />
              <PrivateRoute path="/marketing" component={Marketing} />
              <PrivateRoute path="/affiliate" component={AffiliateStats} />
              <Route path="/focus3-setup" component={Focus3Setup} />
              <Route path="/pico-lbe" component={PicoLBE} />
              <Route path="/update" component={UpdateManual} />
              <Route path="/release-channels" component={ReleaseChannels} />
              <Route
                path="/patch-notes/:releaseId"
                component={PatchNoteReleasePage}
              />
              <Route path="/patch-notes" exact component={PatchNotes} />
              <Route
                path="/validate_login_code"
                component={ValidateLoginCode}
              />
            </div>
          </Router>
        </Content>
        {/* <Footer style={{ textAlign: "center" }}></Footer> */}
      </Layout>
    );
  }
}

export default App;
